import { atom, useAtom } from 'jotai'
import { atomWithReset } from 'jotai/utils'
import { useCallback } from 'react'

export enum LockSortMethod {
  NFT_ID = 'NFT ID',
  LOCK_AMOUNT = 'Lock Amount',
  VOTING_POWER = 'Voting Power',
  EXPIRES = 'Expires',
  EARN = 'Earn',
}

export const filterLockStringAtom = atomWithReset<string>('')
export const sortMethodAtom = atom<LockSortMethod>(LockSortMethod.NFT_ID)
export const sortAscendingAtom = atom<boolean>(false)

/* keep track of sort category for token table */
export function useSetSortMethod(newSortMethod: LockSortMethod) {
  const [sortMethod, setSortMethod] = useAtom(sortMethodAtom)
  const [sortAscending, setSortAscending] = useAtom(sortAscendingAtom)

  return useCallback(() => {
    if (sortMethod === newSortMethod) {
      setSortAscending(!sortAscending)
    } else {
      setSortMethod(newSortMethod)
      setSortAscending(false)
    }
  }, [sortMethod, setSortMethod, setSortAscending, sortAscending, newSortMethod])
}
